import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import ArrowBack from "../../common/images-new/arrow-back-black-icon.svg";
import ButtonHashtag from "../../components/Button/ButtonHashtag";
import Comment from "../../components/LikeComment/Comment";
import AvatarGroup from "../../components/LikeComment/AvatarGroup";
import LikeComment from "../../components/LikeComment/LikeComment";
import PageWrapper from "../PageWrapper";
import hmenu_user from "../../common/images-new/no-profile-pic.png";
import { useParams } from "react-router-dom";
import moment from "moment";
import axios from "axios";
import { serverUrl } from "../../components/Helpers/Config";
import {
  getProfilePic,
  convertDateFormat,
  addAttribute,
  tokenAuthorize,
} from "../../components/Helpers/Common";
import readingTime from "reading-time";
import CommentInput from "../../components/LikeComment/CommentInput";
import { staticFiles } from "../../components/Helpers/Static";
import { ActiveIconColor, BgWhite, Card, TextGray } from "../Theme";
import { MdDescription, MdKeyboardArrowLeft } from "react-icons/md";
import JournalHashtag from "../../components/Button/JournalHashtag";
import SortToggle from "../../components/Button/SortToggle";
import { ButtonCommonTopNew, DivBadge } from "../Theme";
import { BiLeftArrowAlt } from "react-icons/bi";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { GET_THEME_LOADER } from "../../redux/actions/auth";
import RichContent from "../../components/Editor/RichContent";
const FILE_UPLOAD = staticFiles.fileUpload;
const NO_IMAGE = staticFiles.noImage;

function getQueryParam(key) {
  const params = new URLSearchParams(window.location.search);
  return params.get(key);
}
const GuestPublicPostView = (props) => {
  const history = useHistory();
  const location = useLocation();
  const { userId, postId } = useParams();
  const dispatch = useDispatch();
  const profileId = getQueryParam("profile_id");
  const userProfile = useSelector((state) => state.auth.user);
  // const profileTheme = useSelector(state => state.auth.profileTheme);
  const profileTheme = JSON.parse(localStorage.getItem("userTheme" + userId));

  const profile = {
    name: userProfile ? userProfile.fullname : "",
    photo: userProfile ? userProfile.photo : hmenu_user,
  };

  const [commentList, setCommentList] = useState([]);
  const [comment, setComment] = useState("");
  const [likesList, setLikesList] = useState([]);
  const [postData, setPostData] = useState({});

  useEffect(() => {
    getPost(postId);
    getLikes(postId);
    getComments(postId);
  }, []);

  const goBack = () => {
    const prevPage =
      location.state && location.state.src
        ? location.state.src
        : `/public/${userId}?profileId=${profileId}`;
    const tabId =
      location.state && location.state.tabId ? location.state.tabId : 0;

    history.push(prevPage, { tabId });
  };

  const getPost = (postId) => {
    return axios
      .get(serverUrl.GuestReflectionPost + `/${userId}/posts/${postId}`)
      .then((resp) => {
        if (resp.status === 200) {
          let postData = resp.data.post;
          setPostData(postData);
        }
        dispatch({ type: GET_THEME_LOADER, payload: false });
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        if (err.response && err.response.status === 404) {
          history.push("/post-not-found");
        } else {
          console.log(err);
        }
        dispatch({ type: GET_THEME_LOADER, payload: false });
      });
  };

  const getLikes = (postId) => {
    return axios
      .get(serverUrl.GuestReflectionPost + `/${userId}/posts/${postId}/likes`)
      .then((resp) => {
        if (resp.status === 200) {
          let likesList = resp.data.results;
          setLikesList(likesList);
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        console.log(err);
      });
  };

  const getComments = (postId) => {
    return axios
      .get(
        serverUrl.GuestReflectionPost + `/${userId}/posts/${postId}/comments`
      )
      .then((resp) => {
        if (resp.status === 200) {
          let newCommentList = resp.data.results;

          setCommentList(newCommentList);
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        console.log(err);
      });
  };

  const [sortOrder, setsortOrder] = useState("desc");

  const handleSort = (str) => {
    setsortOrder(str);
    localStorage.setItem("sortOrder", str);
    if (str == "asc") {
      const ascSortedData = commentList
        ?.slice()
        .sort((a, b) => new Date(a.created_on) - new Date(b.created_on));
      setCommentList(ascSortedData);
    }
    if (str == "desc") {
      const descSortedData = commentList
        ?.slice()
        .sort((a, b) => new Date(b.created_on) - new Date(a.created_on));
      setCommentList(descSortedData);
    }
    // getComments(postId, str)
  };
  const likePost = (isLiked) => {
    return axios
      .post(serverUrl.ReflectionPost + "/like", {
        reflection_id: postId,
        like: isLiked,
      })
      .then((resp) => {
        if (resp.status === 200) {
          getPost(postId);
          getLikes(postId);
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        console.log(err);
      });
  };

  const commentPost = (commentText) => {
    return axios
      .post(serverUrl.ReflectionPost + "/comment", {
        reflection_id: postId,
        comment: commentText,
      })
      .then((resp) => {
        if (resp.status === 200) {
          setComment("");
          getComments(postId);
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        console.log(err);
      });
  };

  const minutesRead = postData?.reflection_content
    ? readingTime(postData.reflection_content).text
    : null;

  return (
    <PageWrapper hideNav={true} isGuest={true} tempTheme={profileTheme}>
      <div className="border20px shadow-md overflow-hidden cardBackgroundColor pt-6 relative">
        <div className="">
          <div className="flex flex-col sm:flex-row pb-4 px-5 md:px-28 lg:px-36">
            {/* <ButtonCommonTopNew
                            className="rounded-lg px-5 py-2 flex items-center w-max cursor-pointer"
                            onClick={goBack}
                        >
                            <BiLeftArrowAlt className="w-5 h-5" />
                            <h1 className="text-xs lg:text-sm">Back</h1>
                        </ButtonCommonTopNew> */}
            <div
              className={`rounded-lg p-0 flex gap-1 items-center w-max cursor-pointer`}
              onClick={goBack}
            >
              <KeyboardBackspaceIcon className="text-3xl primaryIcon" />
              <h1 className="text-lg blueColor font-semibold">Back</h1>
            </div>
            <p className="text-xl flex justify-center items-center w-full font-semibold blackColor">
              {postData?.reflection_title}
            </p>
          </div>
          <div className="flex flex-row lg:flex-row items-center relative gap-2 px-5 md:px-28 lg:px-36">
            <Link to={"/public/" + userId}>
              <img
                className="h-10 w-10 rounded-full cursor-pointer"
                src={getProfilePic(postData.profile_pic)}
                alt="profile"
              ></img>
            </Link>
            <div className="flex flex-col text-left">
              <div className="flex blackColor gap-1">
                by
                <Link
                  to={"/public/" + userId}
                  className="break-words nav-navigate"
                >
                  <ActiveIconColor className="hover:underline text-base font-semibold">
                    {postData.username}
                  </ActiveIconColor>
                </Link>
              </div>
              {/* <span className="lightColor text-sm flex items-center">
                {moment
                  .utc(postData?.reflection_updated_on)
                  .local()
                  .startOf("seconds")
                  .fromNow()}{" "}
                ({convertDateFormat(postData?.reflection_updated_on)}){" "}
              </span> */}
              <TextGray className="text-sm font-normal flex items-center gap-1">
                {moment
                  .utc(postData?.reflection_updated_on)
                  .local()
                  .startOf("seconds")
                  .fromNow()}
                <span>
                  ({convertDateFormat(postData?.reflection_updated_on)})
                </span>{" "}
                - {minutesRead}
                <span className="flex items-center gap-0">
                  {postData?.reflection_address && (
                    <>
                      <LocationOnIcon
                        className="text-red-600 "
                        style={{ fontSize: "18px" }}
                      />
                      {postData.reflection_address}
                    </>
                  )}
                </span>
              </TextGray>
            </div>
          </div>
          <div className="px-5 md:px-28 lg:px-36">
            <div className="flex flex-row flex-wrap gap-2 my-3">
              {postData.hashtag &&
                postData.hashtag.map((hashtag, index) => (
                  <JournalHashtag key={index} text={hashtag} color="blue" />
                ))}
              {postData.values &&
                postData.values.map((value, index) => (
                  <ButtonHashtag
                    key={index}
                    text={value.value}
                    color="orange"
                  />
                ))}
              {postData.events &&
                postData.events.map((events, index) => (
                  <ButtonHashtag
                    key={index}
                    text={events.value}
                    color="green"
                  />
                ))}
              {postData.courses &&
                postData.courses.map((course, index) => (
                  <ButtonHashtag key={index} text={course.value} color="red" />
                ))}
              {postData.groups &&
                postData.groups.map((group, index) => (
                  <JournalHashtag key={index} text={group.value} color="blue" />
                ))}
            </div>

            {postData.docs && (
              <div className="flex flex-wrap w-full gap-2 my-3">
                {postData.docs.map((item, idx) => {
                  let itemName = item ? item : null;
                  if (itemName) {
                    const itemUrl = itemName;
                    const lastSlash = itemName.lastIndexOf("/");

                    if (lastSlash !== -1) {
                      itemName = itemName.substr(
                        lastSlash + 1,
                        itemName.length - lastSlash - 1
                      );
                    }
                    return (
                      <DivBadge
                        key={idx}
                        className="flex flex-row items-center rounded-lg px-2 justify-center w-max"
                      >
                        <MdDescription className="w-5 h-5 text-white" />
                        <a
                          href={itemUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="flex text-sm p-1 nav-navigate"
                        >
                          <div className=" text-white">{itemName}</div>
                        </a>
                      </DivBadge>
                    );
                  }
                  return null;
                })}
              </div>
            )}

            {/* Post Body */}
            {postData.reflection_image &&
              postData.reflection_image.length > 0 && (
                <img
                  className="border20px object-contain max-w-full h-auto mx-auto"
                  src={postData.reflection_image}
                  alt={postData.reflection_title}
                  onError={(e) => {
                    e.target.src = NO_IMAGE;
                  }}
                />
              )}

            <RichContent
              content={addAttribute(postData.reflection_content)}
              className="mt-5"
            />
          </div>
          {/* Likes and comments */}
          <hr className="my-4" />
          <div className="px-5 md:px-28 lg:px-36">
            <div className="flex flex-row items-center gap-4 my-2">
              {likesList?.length > 0 ? (
                <AvatarGroup likesList={likesList} />
              ) : null}
              <LikeComment
                currentIsLiked={parseInt(postData?.like)} // this data is not available in get single post
                numLikes={postData?.likecount}
                numComments={commentList?.length}
                likesList={likesList}
                readOnly={true}
                isShowcase={true}
                reflection_id={postData.reflection_id}
              />
            </div>
          </div>
          {/* <p className="my-5 md:my-10 flex justify-center text-gray-500">
                        Comments ({commentList.length})
                    </p> */}

          <div className="backgroundColor8 px-5 md:px-28 lg:px-36 rounded-b-2xl border mt-4">
            <div className="items-center relative my-3">
              {commentList?.length != 0 && (
                <>
                  <div className="flex flex-col sm:flex-row items-center justify-between mt-2">
                    <p className="text-base font-semibold blackColor">
                      Comments ({commentList.length})
                    </p>
                    {commentList?.length > 1 && (
                      <SortToggle onChange={handleSort} sortOrder={sortOrder} />
                    )}
                  </div>
                </>
              )}

              {commentList?.length != 0 ? (
                commentList?.map((comment, index) => (
                  <Comment
                    key={index}
                    order={index}
                    profilePic={comment.photo}
                    username={comment.fullname}
                    createdOn={comment.created_on}
                    comment={comment.comments}
                    publicView={true}
                    //deleteView={true}
                    guID={comment.guid}
                    userId={comment.user_id}
                    isPrivate={comment.visibility}
                  />
                ))
              ) : (
                <p className="lightColor text-sm">There is no comment yet.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default GuestPublicPostView;

//  <div className="flex flex-col xl:w-3/4 mx-5 md:mx-28 lg:mx-40 xl:mx-68 mb-5 md:mb-10">
//                         {/* <div className="flex flex-row mt-10 mb-2 md:mb-5 ">
//                             <MdKeyboardArrowLeft className='w-10 h-10 cursor-pointer back-icon' onClick={goBack} />
//                             <p className="ml-3 xl:mr-40 text-4xl font-bold break-words w-full">{postData?.reflection_title}21</p>
//                         </div> */}
//                         <div className="flex flex-row lg:flex-row md:pt-3 mb-3 md:mb-5 ml-7 items-center relative ">
//                             <div className="flex mr-2 md:mr-4">
//                                 <Link to={`/public/${userId}`} className="h-12 w-12">
//                                     <img className="h-12 w-12 rounded-full" src={getProfilePic(postData.profile_pic)} alt="profile"></img>
//                                 </Link>
//                             </div>
//                             <div className="flex-1 flex-col mr-10 text-left">
//                                 <div className='flex'>
//                                     by
//                                     <Link
//                                         to={`/public/${userId}`}
//                                         className="md:text-lg text-black font-semibold break-words nav-navigate"
//                                     >
//                                         <ActiveIconColor className='hover:underline ml-2 -mt-0.5'>{postData.username}</ActiveIconColor>
//                                     </Link></div>
//                                 <TextGray className="text-sm md:text-base font-normal">
//                                     {moment.utc(postData?.reflection_created_on).local().startOf('seconds').fromNow()} ({convertDate(postData?.reflection_created_on)}) - {minutesRead}
//                                 </TextGray>
//                             </div>
//                         </div>
//                         <div className="flex flex-row flex-wrap gap-4 mb-2 mx-7">
//                             {
//                                 postData.hashtag &&
//                                 postData.hashtag.map((hashtag, index) => (
//                                     <JournalHashtag key={index} text={hashtag} color="blue" />
//                                 ))
//                             }
//                             {
//                                 postData.values &&
//                                 postData.values.map((value, index) => (
//                                     <ButtonHashtag key={index} text={value.value} color="orange" />
//                                 ))
//                             }
//                             {
//                                 postData.events &&
//                                 postData.events.map((events, index) => (
//                                     <ButtonHashtag key={index} text={events.value} color="orange" />
//                                 ))
//                             }
//                             {
//                                 postData.courses &&
//                                 postData.courses.map((course, index) => (
//                                     <ButtonHashtag key={index} text={course.value} color="red" />
//                                 ))
//                             }
//                             {
//                                 postData.groups &&
//                                 postData.groups.map((group, index) => (
//                                     <JournalHashtag key={index} text={group.value} color="blue" />
//                                 ))
//                             }
//                         </div>

//                         {
//                             postData.docs &&
//                             postData.docs.map((item, idx) => {
//                                 let itemName = item ? item : null
//                                 if (itemName) {
//                                     const itemUrl = itemName;
//                                     const lastSlash = itemName.lastIndexOf('/');

//                                     if (lastSlash !== -1) {
//                                         itemName = itemName.substr(lastSlash + 1, itemName.length - lastSlash - 1)
//                                     }
//                                     return (
//                                         <div key={idx} className='flex flex-row items-center space-x-2 mt-2 ml-7 lg:mt-5"'>
//                                             <img src={FILE_UPLOAD} alt="file upload" />
//                                             <a
//                                                 href={itemUrl}
//                                                 target="_blank" rel="noopener noreferrer"
//                                                 className='text-gray-500 hover:text-gray-800 cursor-pointer underline break-words nav-navigate'
//                                             >
//                                                 <TextGray className='underline'>{itemName}</TextGray>
//                                             </a>
//                                         </div>
//                                     )
//                                 }

//                                 return null;
//                             })
//                         }
//                     </div>

//                     {/* Post Body */}
//                     {
//                         postData.reflection_image && postData.reflection_image.length > 0 &&
//                         <img
//                             className="mx-auto md:px-20 lg:px-48"
//                             src={postData.reflection_image}
//                             alt={postData.reflection_title}
//                             onError={(e) => { e.target.src = NO_IMAGE }}
//                         />
//                     }

//                     <div className="text-viewer mx-5 md:mx-32 lg:mx-48 xl:mx-60 my-5 break-words"
//                         dangerouslySetInnerHTML={{ __html: addAttribute(postData.reflection_content) }}
//                     />

//                     {/* Likes and comments */}
//                     <hr className="w-3/4 mx-10 lg:mx-40 self-center" />
//                     <div className="flex flex-1 md:flex-row mb-5 md:mb-10 mt-5 md:mt-10 mx-5
//                                 md:mx-32 lg:mx-48 xl:mx-60 md:space-x-5">
//                         {likesList?.length > 0
//                             ? <AvatarGroup likesList={likesList} />
//                             : null
//                         }
//                         <LikeComment
//                             currentIsLiked={parseInt(postData?.like)} // this data is not available in get single post
//                             numLikes={postData?.likecount}
//                             numComments={commentList?.length}
//                             likesList={likesList}
//                             readOnly={true}
//                             isShowcase={true}
//                             reflection_id={postData.reflection_id}
//                         />
//                     </div>
//                     <p className="my-5 md:my-10 flex justify-center text-gray-500">
//                         Comments ({commentList.length})
//                     </p>

//                     <div className="md:pt-3 mb-5 items-center relative mx-5 md:mx-32 lg:mx-48 xl:mx-60">
//                         {commentList &&
//                             commentList.map((comment, index) => (
//                                 <Comment
//                                     key={index}
//                                     order={index}
//                                     profilePic={comment.photo}
//                                     username={comment.fullname}
//                                     createdOn={comment.created_on}
//                                     comment={comment.comments}
//                                     publicView={true}
//                                     deleteView={true}
//                                     guID={comment.guid}
//                                     userId={comment.user_id}
//                                     isPrivate={comment.visibility}
//                                 // handleDelete = {() => deleteComment(comment.reflection_comment_id)}
//                                 // numLikes = {comment.numLikes}
//                                 // numComments = {comment.numComments}
//                                 />
//                             ))
//                         }
